"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
const i0 = require("@angular/core");
const i1 = require("../../../projects/angular-sdk/src/4d-mapper.service");
const i2 = require("./acl/acl.service");
const i3 = require("@ngx-translate/core");
const i4 = require("@angular/common/http");
const i5 = require("../xs/services/events/application-events.service");
const i6 = require("../v2/commons/map-data.service");
DEBUG_1.DEBUG.open('/app/commons/map.service.ts');
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const global_1 = require("./global");
const Constants_1 = require("./Constants");
const acl_service_1 = require("./acl/acl.service");
const http_1 = require("@angular/common/http");
const rxjs_2 = require("rxjs");
const core_1 = require("@ngx-translate/core");
const application_events_service_1 = require("../xs/services/events/application-events.service");
const event_listener_interface_1 = require("../xs/interfaces/event-listener.interface");
const identify_interface_1 = require("../xs/interfaces/identify.interface");
const eventify_class_1 = require("../xs/services/events/eventify.class");
const await_class_1 = require("../xs/controllers/await.class");
const map_data_service_1 = require("../v2/commons/map-data.service");
const Cesium = window.Cesium;
class MapService {
    constructor(fourD, permissions, translate, httpClient, applicationEvents, v2Maps) {
        this.fourD = fourD;
        this.permissions = permissions;
        this.translate = translate;
        this.httpClient = httpClient;
        this.applicationEvents = applicationEvents;
        this.v2Maps = v2Maps;
        this.__ID = null;
        this.__EVENTS = null;
        this.debug = Constants_1.Constants.debug_off;
        this.debugPrimary = Constants_1.Constants._orange;
        this.debugSecondary = Constants_1.Constants._gray;
        this.debugData = null;
        // active photos, transforms and shapes
        this.sceneTransforms = [];
        this.scenePhotos = [];
        this.sceneShapes = [];
        // project wide annotations
        this.annotations = [];
        this.newAnnotationReady = new rxjs_1.Subject();
        // all scenes for project
        this.scenes = [];
        // cesium references
        this.helper = null;
        this.viewer = null;
        this.isD360 = null;
        this.isAgronomeye = null;
        // shares
        this.shareClients = [];
        // observables for the various update events
        // What is sceneWChange change as opposed to the sceneChange? (@haresh ?)
        this._projectLoadingObs = null;
        this._sceneLoadingObs = null;
        // in loadScene() at the beginning
        this._sceneWChangeSubj = new rxjs_1.Subject();
        this._sceneWChangeObj = this._sceneWChangeSubj.asObservable();
        // updateScene(), loadScene() towards the end, onSceneChange()
        this._sceneChangeSubj = new rxjs_1.Subject();
        this._sceneChangeObj = this._sceneChangeSubj.asObservable();
        // loadCesium()
        this._cesiumReadySubj = new rxjs_1.Subject();
        this._cesiumReadyObj = this._cesiumReadySubj.asObservable();
        // refreshPhotos() start
        this._photoWChangeSubj = new rxjs_1.Subject();
        this._photoWChangeObs = this._photoWChangeSubj.asObservable();
        // refreshPhotos() end
        this._photoChangeSubj = new rxjs_1.Subject();
        this._photoChangeObs = this._photoChangeSubj.asObservable();
        /*
          Why is there an _annotChange* AND an _annot1Change*?
        */
        this._annotChangeSubj = new rxjs_1.Subject();
        this._annotChangeObs = this._annotChangeSubj.asObservable();
        this._annot1ChangeSubj = new rxjs_1.Subject();
        this._annot1ChangeObs = this._annot1ChangeSubj.asObservable();
        this._cameraDebouncerSub = new rxjs_1.Subject();
        this._cameraDebouncer = this._cameraDebouncerSub.asObservable().pipe(operators_1.debounceTime(3000));
        this._projSubj = new rxjs_1.Subject();
        this._projObs = this._projSubj.asObservable();
        this.projectSettingEPSGCodeChanged = new rxjs_1.Subject();
        this.projectSettingMeasurementUnitChanged = new rxjs_1.Subject();
        this.onSingleImageForAttachementChange = new rxjs_1.Subject();
        this.terranCompareStarted = new rxjs_1.Subject();
        this.terranCompareStartedObs = this.terranCompareStarted.asObservable();
        this.showHideAllPhotosSub = new rxjs_1.Subject();
        this.showPhotos = [];
        this.resetLastLocation = false;
        this.localPhotosReadySub = new rxjs_1.Subject();
        this.moveActive = false;
        this.currentSplitIndex = 0;
        this.datasetUploadingOrTilling = new rxjs_1.Subject();
        // main list of incoming data files (uploading, waiting for action, processing, errors, etc.)
        this.datasetForLayers = [];
        // incomingData:incomingDataManager = null;
        // permissions: AclService = null;
        this.hasLoadedAnnotations = false;
        // location marker (for a user's location)
        this.locationShape = null;
        // temporary for debugging
        this.debug_entities = [];
        // coordinates for users location
        // locationCartographic:any = new Cesium.Cartographic(0,0,20);
        // geolocation is the user's position, camera view, orientation and related info
        this.geolocation = {
            longitude: 0,
            latitude: 0,
            height: 5,
            sampledHeight: 0,
            cameraHeight: 0
        };
        this.cameralocation = {
            longitude: 0,
            latitude: 0,
            height: 5,
            sampledHeight: 0,
            cameraHeight: 0,
            dateClient: null,
            dateCamera: null,
            timeZone: null,
            timeLabel: null,
            simulatedTimeLabel: null
        };
        this.INVALID_PROJECT = 'Invalid project';
        /*   refactored into its own component
      
      
        splitTransforms() {
          if (this.slider && !this.slider.hidden) {
            return;
          }
          this.slider = document.getElementById('slider');
          this.sideTransform = document.getElementById('sideTransform');
          this.slider.hidden = false;
          this.sideTransform.hidden = false;
      
          if (this.viewer.imageryLayers._layers.length > 0) {
            this.currentSplitIndex = 0;
            let firstActiveTransform = undefined;
            let secondActiveTransform = undefined;
            for (let st of this.sceneTransforms) {
              if (this.scene['layerProps'][MapService.TOGGLE + st.id] && this.isValidForChangingOpacity(st) && !firstActiveTransform) {
                firstActiveTransform = st;
              } else if (this.scene['layerProps'][MapService.TOGGLE + st.id] && this.isValidForChangingOpacity(st) && firstActiveTransform) {
                secondActiveTransform = st;
                break;
              }
      
            }
            if (firstActiveTransform) {
      
              this.viewer.imageryLayers._layers.forEach(l => {
                if (l._imageryProvider._resource.url.indexOf(firstActiveTransform.id) !== -1) {
                  return;
                }
                this.currentSplitIndex++;
              })
              if (this.currentSplitIndex < this.viewer.imageryLayers._layers.length) {
                this.leftSideTransform = firstActiveTransform.ds_name;
                if (secondActiveTransform) {
                  this.rightSideTransform = secondActiveTransform.ds_name;
                } else {
                  this.rightSideTransform = ' ';
                }
                this.viewer.imageryLayers._layers[this.currentSplitIndex].splitDirection = Cesium.ImagerySplitDirection.LEFT;
                this.viewer.scene.imagerySplitPosition = (this.slider.offsetLeft) / this.slider.parentElement.offsetWidth;
                
                var handler = new Cesium.ScreenSpaceEventHandler(this.slider);
                handler.setInputAction(() => {
                  this.moveActive = true;
                }, Cesium.ScreenSpaceEventType.LEFT_DOWN);
                handler.setInputAction(() => {
                  this.moveActive = true;
                }, Cesium.ScreenSpaceEventType.PINCH_START);
                handler.setInputAction(this.move.bind(this), Cesium.ScreenSpaceEventType.MOUSE_MOVE);
                handler.setInputAction(this.move.bind(this), Cesium.ScreenSpaceEventType.PINCH_MOVE);
                handler.setInputAction(() => {
                  this.moveActive = false;
                }, Cesium.ScreenSpaceEventType.LEFT_UP);
                handler.setInputAction(() => {
                  this.moveActive = false;
                }, Cesium.ScreenSpaceEventType.PINCH_END);
              } else {
                this.slider.hidden = true;
                this.sideTransform.hidden = true;
              }
            } else {
              this.slider.hidden = true;
              this.sideTransform.hidden = true;
            }
          }
      
        }
      
      
        move(movement) {
          if (!this.moveActive) {
            return;
          }
      
          var relativeOffset = movement.endPosition.x;
          var splitPosition = (this.slider.offsetLeft + relativeOffset) / this.slider.parentElement.offsetWidth;
          this.slider.style.left = 100.0 * splitPosition + '%';
          this.viewer.scene.imagerySplitPosition = splitPosition;
        }
      
        unsplitTransforms() {
          this.leftSideTransform = undefined;
          this.rightSideTransform = undefined;
          if (this.slider && !this.slider.hidden) {
            this.slider.hidden = true;
            this.sideTransform.hidden = true;
            if (this.currentSplitIndex !== 0) {
              if (this.currentSplitIndex < this.viewer.imageryLayers._layers.length) {
                this.viewer.imageryLayers._layers[this.currentSplitIndex].splitDirection = 0;
                this.viewer.scene.imagerySplitPosition = 0;
              }
              this.reorderTransform();
            }
          }
        }
      
        */
        /* OLDER items from Heresh, look to standardize */
        // Alex: I've killed this one, doesn't seem to be in use anywhere except photogrammetry, and there it just listens for it, but no one is setting it
        // loadedProject: Subject<Project> = new Subject<Project>();
        this.transformsFromFolder = new rxjs_1.Subject();
        this.FOURDDMAPPER_REFERENCE = 'REFERENCE';
        this.FOURDDMAPPER_REFERENCE_TICK = 'REFERENCE_TICK';
        this.FOURDDMAPPER_META = 'META';
        this.DATA_FROM_FOLDER = 'DATA_FROM_FOLDER';
        this.REFERENCE_ANNOTATION = 'REFERENCE_ANNOTATION';
        this.loadImages = new rxjs_1.Subject();
        this.JOB_EPSG_CODE = 'JOB_EPSG_CODE';
        this.localPhotos = [];
        this.JOB_EPSG_CODE_DESC = 'JOB_EPSG_CODE_DESC';
        this.JOB_REF_EPSG_CODE = 'JOB_REF_EPSG_CODE';
        this.JOB_REF_EPSG_CODE_DESC = 'JOB_REF_EPSG_CODE_DESC';
        DEBUG_1.DEBUG.log('/app/commons/map.service.ts');
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.__EVENTS = event_listener_interface_1.XsEventListenerInterface.__init(this);
        // refactor of datasetForLayers --- moved into incomingData.service.ts
        // this.incomingData = new incomingDataManager( this.fourD );
        translate.get('GENERIC.INVALID_PROJECT').subscribe(s => this.INVALID_PROJECT = s);
        // these new events are rewiring these old events for new ways of doing it throughout the application
        // --------------------------------------------------------------------------------------------------
        // register against the generic 'sceneChange' event, and inject our Subjects for Start and End
        applicationEvents.register('mapServiceSceneChangeStart', this._sceneWChangeSubj, eventify_class_1.XsEventify.REGISTER_ONLY_ONE, this.__ID);
        applicationEvents.register('mapServiceSceneChangeEnd', this._sceneChangeSubj, eventify_class_1.XsEventify.REGISTER_ONLY_ONE, this.__ID);
        // register against the generic 'photosChange' event, and inject our Subjects for Start and End
        applicationEvents.register('mapServicePhotosChangeStart', this._photoWChangeSubj, eventify_class_1.XsEventify.REGISTER_ONLY_ONE, this.__ID);
        applicationEvents.register('mapServicePhotosChangeEnd', this._photoChangeSubj, eventify_class_1.XsEventify.REGISTER_ONLY_ONE, this.__ID);
        // register against the generic 'annotationsChange' event, and inject our Subjects for Start and End
        applicationEvents.register('mapServiceAnnotationsChangeStart', this._annotChangeSubj, eventify_class_1.XsEventify.REGISTER_ONLY_ONE, this.__ID);
        // register new events for transforms, and inject our Subjects for Start and End
        applicationEvents.register('mapServiceTransformsChangeStart', null, eventify_class_1.XsEventify.REGISTER_ONLY_ONE, this.__ID);
        applicationEvents.register('mapServiceTransformsChangeEnd', null, eventify_class_1.XsEventify.REGISTER_ONLY_ONE, this.__ID);
        // listen to the debounced camera updates (@alex sure, but what does that mean?)
        this._cameraDebouncer.subscribe(movement => {
            if (this.debug) {
                console.log('%c map.service %c cameraDebouncer()', this.debugPrimary, this.debugSecondary, movement);
            }
            rxjs_1.forkJoin([
                this.v2Maps.onProjectReady().pipe(operators_1.concatMap(_ => this.v2Maps.annotations.state.pipe(operators_1.take(1), operators_1.tap(p => {
                    if (this.debug) {
                        console.log('map.service :: cameraDebouncer() READY', movement);
                    }
                    this.annotations = p;
                    this.checkAndClipPlanesFromAnnotation();
                    var v = p.slice();
                    if (this.newAnnotation)
                        v.push(this.newAnnotation);
                    this._annotChangeSubj.next(v);
                })))),
                this.refreshPhotos(movement ? movement.endPosition : undefined)
            ]).subscribe();
        });
    }
    // listen out for when the mapViewer / CesiumMap is ready (ref; XsEventListenerInterface)
    ___mapViewer(obj = null) {
        if (this.debug) {
            console.log('%c mapService %c ___mapViewer, caught them ...', this.debugPrimary, this.debugSecondary, obj);
        }
        this.viewer = obj.viewer;
        this.helper = obj.helper;
        this._cesiumReadySubj.next();
    }
    onReady() {
        if (this.currentProject) {
            if (this.debug) {
                console.log('%c map.service %c onReady()', this.debugPrimary, this.debugSecondary, this.currentProject);
            }
            return rxjs_1.of(this.currentProject);
        }
        if (this.debug) {
            console.log('%c map.service %c onReady() _projObs', this.debugPrimary, this.debugSecondary, this._projObs);
        }
        return this._projObs;
    }
    setNewAnnotation(a) {
        this.newAnnotation = a;
        var items = this.annotations.slice();
        if (a) {
            items.push(a);
            this._annotChangeSubj.next(items);
        }
        else {
            this._annotChangeSubj.next(items);
        }
    }
    updateAnnotation(a, dontSave = false) {
        // just fire event
        if (dontSave) {
            this._annot1ChangeSubj.next(a);
        }
        else {
            a['saved'] = true;
            a['entity_config'] = null;
            return a.saveObservable().pipe(operators_1.tap(_ => {
                this.newAnnotation = undefined;
                if (!this.annotations.find(aa => aa.id == a.id)) {
                    this.annotations.push(a);
                    this.v2Maps.annotations.add(a);
                    this._annotChangeSubj.next(this.annotations.slice());
                }
                else {
                    this._annot1ChangeSubj.next(a);
                }
            }));
        }
    }
    refreshAnnotations() {
        if (this.debug) {
            console.log('%c map.service %c refreshAnnotations()', this.debugPrimary, this.debugSecondary);
        }
        return this.v2Maps.onProjectReady().pipe(operators_1.concatMap(_ => this.v2Maps.annotations.state.pipe(operators_1.take(1), operators_1.tap(p => {
            if (this.debug) {
                console.log('%c map.service %c refreshAnnotations() READY', this.debugPrimary, this.debugSecondary);
            }
            this.hasLoadedAnnotations = true;
            this.annotations = p;
            this.checkAndClipPlanesFromAnnotation();
            this._annotChangeSubj.next(p);
        }))));
    }
    /*
    setCameraHeight( height:number ) {
      if ( this.viewer && this.viewer.scene && this.viewer.scene.camera && this.viewer.scene.camera.position ) {
        let newcart = this.coordHelper.updateCesiumCartesianHeight(this.viewer.scene.camera.position, Math.round(height) );
        // console.log('@@@', height, this.viewer.scene.camera.position, newcart );
        this.viewer.scene.camera.position = newcart;
      }
    }
  */
    // hack; it's tricky to get a fourD.V into an Annotation, so just a quick helper to create a new one
    getNewTransform() {
        return new _4d_mapper_1.Transform(this.fourD.V);
    }
    /*
    refactor; disabling this bananas injection of the mapComponent just to pull out the coordinates. Just friggin
              call RefreshPhotos with coordinates you may or may not have got, like all good children would do!
  
    refreshPhotosFromCurrentCord(mapComp: MapComponent) {
      if ( ! mapComp ) {
        return;
      }
      return this.refreshPhotos(mapComp.currentCoord ? mapComp.currentCoord.position : null, mapComp.vertical_offset)
    }
  */
    refreshPhotos(position = null, applyVerticalOffset = 0) {
        this._photoWChangeSubj.next([]);
        let query = this.scene.photos;
        if (position) {
            if (this.debug) {
                console.log('%c map.service %c refreshPhotos() 1. POSITION', this.debugPrimary, this.debugSecondary, position);
            }
            if (position.latitude && !Number.isNaN(position.latitude)) {
                let q = position.latitude + ';' + position.longitude + ';';
                if (this.debug) {
                    console.log('%c map.service %c refreshPhotos(pos,query,verticalOffset) 2. long,lat', this.debugPrimary, this.debugSecondary, position, q);
                }
                if (position.height && !Number.isNaN(position.height)) {
                    q = q + (position.height - applyVerticalOffset) + ';';
                }
                query = query.equals('camera', q);
            }
            else if (position.x && !Number.isNaN(position.x)) {
                var carto = Cesium.Cartographic.fromCartesian(position);
                let q = carto.latitude + ';' + carto.longitude + ';';
                if (this.debug) {
                    console.log('%c map.service %c refreshPhotos(pos,query,verticalOffset) 3. x,y,z', this.debugPrimary, this.debugSecondary, position, carto, q);
                }
                if (carto.height && !Number.isNaN(carto.height)) {
                    q = q + (carto.height - applyVerticalOffset) + ';';
                }
                query = query.equals('camera', q);
            }
            else {
                if (this.debug) {
                    console.log('%c map.service %c refreshPhotos() 4. incoming position has non-numbers', this.debugPrimary, this.debugSecondary, position);
                }
            }
        }
        if (this.debug) {
            console.log('%c map.service %c refreshPhotos(pos,query,verticalOffset) 5.', this.debugPrimary, this.debugSecondary, position, query, applyVerticalOffset);
        }
        return query.limit(1000003).queryObservable().pipe(operators_1.tap(p => {
            this.scenePhotos = position ? p.items.sort((a, b) => {
                if (a['selected_position'] && a['selected_position'].x > 0 && (!b['selected_position'] || b['selected_position'].x == -1)) {
                    return -10000000000;
                }
                else if (b['selected_position'] && b['selected_position'].x > 0 && (!a['selected_position'] || a['selected_position'].x == -1)) {
                    return 1000000000;
                }
                else if (a['distance'] && b['distance'])
                    return a['distance'] - b['distance'];
                else
                    return 0;
            }) : p.items;
            this._photoChangeSubj.next(p.items.slice());
        }));
    }
    /**
     * Update annotations using search
     * @param cesiumCamera
     */
    searchAnnots(complexQuery) {
        if (!this.currentProject || !this.currentProject.id) {
            return rxjs_1.of(null);
        }
        var projectQ = {
            op: '=',
            col: 'project',
            val: this.currentProject.id
        };
        if (this.debug) {
            console.log('%c MapService %c searchAnnots()', this.debugPrimary, this.debugSecondary, complexQuery);
        }
        return this.fourD.searchFor(_4d_mapper_1.Annotation).complexQuery(complexQuery ?
            {
                op: 'and',
                items: [projectQ, complexQuery]
            } :
            projectQ).limit(1000004).queryObservable().pipe(operators_1.tap(p => {
            this.v2Maps.annotations.values = p.items;
            this.annotations = p.items;
            this.checkAndClipPlanesFromAnnotation();
            this._annotChangeSubj.next(p.items.slice());
        }));
    }
    /**
     *
     * @param a Delete an annotation from server
     */
    deleteAnnotation(a) {
        if (a['clipPlanes'] !== undefined) {
            a['points'].forEach(point => {
                this.clipPlanes(point, false);
            });
        }
        a['saved'] = true;
        return a.destroyObservable().pipe(operators_1.tap(_ => {
            this.newAnnotation = undefined;
            this.annotations = this.annotations.filter(aa => aa.id != a.id);
            this.v2Maps.annotations.values = this.annotations;
            this._annotChangeSubj.next(this.annotations.slice());
        }));
    }
    /**
     *
     * @param a Remove all photos from active Scene
     */
    removeActiveScenePhotos() {
        return this.scene.removeAllImages().pipe(operators_1.tap(_ => {
            this.scenePhotos = [];
            this.scene._photo_count = 0;
            delete this.localPhotos[this.scene.id];
            this._photoChangeSubj.next([]);
        }));
    }
    /**
     * Update the position of the cesium camrea
     * @param cesiumCamera
     */
    updateCameraPosition(cesiumCamera, movment) {
        return this._cameraDebouncerSub.next(movment);
    }
    /**
     * Remove a transform from a scene
     * @param t
     */
    removeFromCurrentScene(t) {
        if (t['clipGlobe'] != undefined) {
            this.clipGlobe(false, t);
        }
        return this.scene.children.removeObservable(t).pipe(operators_1.flatMap(_ => {
            delete this.scene['layerProps'][MapService.TOGGLE + t.id];
            delete this.scene['layerProps'][MapService.ALPHA + t.id];
            delete this.scene['layerProps'][MapService.VIEW + t.id];
            this.sceneTransforms = this.sceneTransforms.filter(s => s.id != t.id);
            this.saveSceneTransformsOrders();
            this.checkAndClipPlanesFromTransforms();
            this.scenePhotos = this.scenePhotos.filter(s => s.id != t.id);
            if (this.scene._cachedTransforms) {
                this.scene._cachedTransforms = this.scene._cachedTransforms.filter(tt => tt.id != t.id);
            }
            return this.scene.saveObservable();
        }));
    }
    /**
     * Remove a scene
     * @param tg
     */
    deleteScene(tg) {
        if (this.currentProject['lastActiveScene'] == tg.id) {
            delete this.currentProject['lastActiveScene'];
            this.currentProject.saveObservable().subscribe();
        }
        return tg.destroyObservable().pipe(operators_1.flatMap(_ => {
            this.scenes = this.scenes.filter(s => s.id != tg.id);
            if (this.scene && this.scene.id == tg.id) {
                if (this.scenes.length > 0) {
                    this.loadScene(this.scenes[0].id).subscribe();
                    return rxjs_1.of('');
                }
                else {
                    this.scene = null;
                    this.sceneTransforms = null;
                    this.checkAndClipPlanesFromTransforms();
                    return rxjs_1.of('');
                }
            }
        }));
    }
    /**
     * Update the scene without reloading allo of the scens meta
     * @param tg
     */
    updateScene(tg) {
        this.scenes = this.scenes.filter(s => s.id != tg.id);
        this.scenes.push(tg);
        this.scene = tg;
        // clear the list of layers
        this.sceneTransforms = [];
        this._sceneChangeSubj.next(tg);
        if (this.debug) {
            console.log('%c map.service %c updateScene()', this.debugPrimary, this.debugSecondary, tg, this.scenes);
        }
    }
    layerPropsDefaults(t) {
        const check = [
            { key: MapService.TOGGLE + t.id, default: true },
            { key: MapService.ALPHA + t.id, default: 1 },
            { key: MapService.VIEW + t.id, default: true },
            { key: '_' + MapService.ALPHA + t.id, default: false }
        ];
        check.forEach(item => {
            if (!this.scene['layerProps'].hasOwnProperty(item.key) || this.scene['layerProps'][item.key] == undefined) {
                this.scene['layerProps'][item.key] = item.default;
            }
        });
        // this.scene.saveObservable().subscribe();
    }
    /**
     * Update the scene by loading all of the scenes meta
     * @param tgId
     * @mustReloadScene if we want to forcefully reload scene in case of any job result available or any transforms added
     */
    loadScene(tgId, mustReloadScene = true) {
        const xtrue = false;
        var flyThere = null;
        var found = this.scenes.find(s => s.id == tgId);
        if (!found && this.scenes.length > 0) {
            found = this.scenes[0];
        }
        if (xtrue || this.debug) {
            console.log('%c map.service %c loadScene(' + tgId + ',' + mustReloadScene + ')', this.debugPrimary, this.debugSecondary, tgId, found, this.scenes);
        }
        if (found && this.scene && this.scene == found && !mustReloadScene) {
            if (xtrue || this.debug) {
                console.log('%c map.service %c loadScene() return', this.debugPrimary, this.debugSecondary, tgId, this.scene);
            }
            return rxjs_1.of(this.scene);
        }
        else if (this._sceneLoadingObs) {
            if (xtrue || this.debug) {
                console.log('%c map.service %c loadScene() return sceneLoadingObs', this.debugPrimary, this.debugSecondary, tgId);
            }
            return this._sceneLoadingObs;
        }
        // found a scene?
        else if (found) {
            if (xtrue || this.debug) {
                console.log('%c map.service %c loadScene() found', this.debugPrimary, this.debugSecondary, tgId);
            }
            this._sceneWChangeSubj.next(tgId);
            this.scene = found;
            if (!found['layerProps'])
                found['layerProps'] = {};
            this.scenePhotos = [];
            this._sceneLoadingObs = found.children.limit(1000005).queryObservable().pipe(operators_1.map(s => {
                if (xtrue || this.debug) {
                    console.log('%c map.service %c loadScene() LOADING SCENE', this.debugPrimary, this.debugSecondary, tgId, s, this._sceneLoadingObs);
                }
                this.applicationEvents.triggerStart('mapServiceTransformsChange');
                s.items.forEach(t => {
                    // hack; reset this showOptions for all layers
                    t['showOptions'] = false;
                    this.layerPropsDefaults(t);
                    // are any of these settings worth exposing in the UI? (@alex)
                    if ((t['ds_type_uid'] == 'laslaz' || t['ds_type_uid'] == 'laslaz-tiles') && !t.pointCloudShading) {
                        t.pointCloudShading = {
                            'geometricErrorScale': 1,
                            'attenuation': true,
                            'maximumAttenuation': 8,
                            'baseResolution': 0,
                            'eyeDomeLighting': false,
                            'eyeDomeLightingStrength': 1,
                            'eyeDomeLightingRadius': 1
                        };
                        // t.saveObservable().subscribe();
                    }
                });
                this.sceneTransforms = s.items;
                this.applicationEvents.triggerEnd('mapServiceTransformsChange', s.items);
                this.refreshPhotos().subscribe();
                this.reorderSavedSceneTranformOrders();
                this.checkAndClipPlanesFromTransforms();
                // found any to fly to?
                // if (flyThere) {
                // then fly!
                // if (this.debug) { console.log('%c map.service %c loadScene() flyTo', this.debugPrimary, this.debugSecondary, flyThere); }
                // this.helper.sendCameraTo(flyThere);
                // }
                this._sceneLoadingObs = null;
                if (xtrue || this.debug) {
                    console.log('%c map.service %c loadScene() trigger sceneChangeSubj', this.debugPrimary, this.debugSecondary, found);
                }
                this._sceneChangeSubj.next(found);
                if (xtrue || this.debug) {
                    console.log('%c map.service %c loadScene() return found scene', this.debugPrimary, this.debugSecondary, found);
                }
                return found;
            }));
            if (xtrue || this.debug) {
                console.log('%c map.service %c loadScene() return sceneLoadingObs', this.debugPrimary, this.debugSecondary, this._sceneLoadingObs);
            }
            return this._sceneLoadingObs;
        }
        else {
            Constants_1.Constants.hideHangOn();
        }
        if (xtrue || this.debug) {
            console.log('%c map.service %c loadScene() return sceneChangeObj', this.debugPrimary, this.debugSecondary, this._sceneChangeObj);
        }
        return this._sceneChangeObj;
    }
    /**
     * Updaing the current project using the project ID
     */
    loadProject(pid, sceneId = null) {
        if (this.debug) {
            console.log('%c mapService %c loadProject()', this.debugPrimary, this.debugSecondary, pid, sceneId);
        }
        if (!this.fourD.projects) {
            // TODO you shouldnt have any automatic logic for chaning account here
            if (this.debug) {
                console.log('%c map.Service %c loadProject [no projects, piping]', this.debugPrimary, this.debugSecondary);
            }
            return this.fourD.onReady().pipe(operators_1.flatMap(p => this.fourD.setActiveTeam(p[0].uid)), operators_1.flatMap(_ => this.loadProject(pid, sceneId)));
        }
        var p = this.fourD.projects.find(p => p.id == pid);
        if (this.debug) {
            console.log('%c mapService %c loadProject pid, sceneId, found project', this.debugPrimary, this.debugSecondary, pid, sceneId, p);
        }
        if (!p) {
            return rxjs_1.Observable.throw({ message: this.INVALID_PROJECT });
        }
        // if there is a current project, but it's different frome the newly loaded one
        if (this.currentProject && p.id != this.currentProject.id) {
            this.currentProject = null;
        }
        // TODO wrong
        // if (this.currentProject == p && !sceneId || (sceneId && this.scene && this.scene.id === sceneId)) {
        //  this.refreshAnnotations().subscribe();
        // return of(p)
        // }
        //change last used date
        // p.saveObservable().subscribe(value => {
        //   value.fetchObservable().subscribe();
        // });
        if (this.currentProject) {
            if (this.debug) {
                console.log('%c map.service %c loadProject() RETURN this.currentProject', this.debugPrimary, this.debugSecondary);
            }
            return rxjs_1.of(this.currentProject);
        }
        if (!this._projectLoadingObs) {
            if (this.debug) {
                console.log('%c map.service %c loadProject() CREATE this._projectLoadingObs', this.debugPrimary, this.debugSecondary);
            }
            this.currentProject = p;
            this._projectLoadingObs = rxjs_1.forkJoin([
                p.shareClients.limit(1000006).queryObservable().pipe(operators_1.tap(s => this.shareClients = s.items)),
                p.groupList().pipe(operators_1.tap(tgs => this.scenes = tgs))
            ]).pipe(operators_1.flatMap(_ => {
                if (sceneId) {
                    if (this.debug) {
                        console.log('%c map.service %c loadProject() map LoadScene(id)', this.debugPrimary, this.debugSecondary, p);
                    }
                    return this.loadScene(sceneId);
                }
                else if (p['lastActiveScene']) {
                    if (this.debug) {
                        console.log('%c map.service %c loadProject() map LoadScene(lastActiveScene)', this.debugPrimary, this.debugSecondary, p);
                    }
                    return this.loadScene(p['lastActiveScene']);
                }
                else {
                    if (this.debug) {
                        console.log('%c map.service %c loadProject() map LoadScene(n) PICK FIRST', this.debugPrimary, this.debugSecondary, p, this.scenes.length ? this.scenes[0].id : -1);
                    }
                    return this.loadScene(this.scenes.length ? this.scenes[0].id : -1);
                }
            }), operators_1.map(_ => {
                // this.currentProject = p;
                // console.log ( 'mapService @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@' );
                this.isAgronomeye = this.fourD.apis.find(a => a.processorImpl == global_1.APITypes.Agronomeye.IMPL && a['project'] && a['project'].id == this.currentProject.id);
                this.canWrite = this.fourD.activeTeam.canWrite; // || this.currentProject['isMember']
                this._projectLoadingObs = null;
                this.isD360 = !!this.fourD.activeTeam.hasApiEnabled(global_1.APITypes.Datum360.NAME) && !!this.fourD.getApi(global_1.APITypes.Datum360.NAME);
                if (this.debug) {
                    console.log('%c map.service %c loadProject() !! CREATED !! this._projectLoadingObs', this.debugPrimary, this.debugSecondary, p);
                }
                this._projSubj.next(p);
                return p;
            }));
        }
        if (this.debug) {
            console.log('%c map.service %c loadProject() RETURN this._projectLoadingObs', this.debugPrimary, this.debugSecondary);
        }
        return this._projectLoadingObs;
    }
    deinit() {
        this.scenes = [];
        this.currentProject = null;
        this.sceneTransforms = [];
        this.annotations = [];
        this.scene = null;
    }
    /**
     * Generate a share link
     * @param email email to send invite to
     * @param pin the point to mark when share is loaded
     * @param camera position of camera
     */
    addShare(inp, camera) {
        // inp = { email:'...', permissions:{...}, expire: false|number }
        let name = inp['name'] ? inp['name'] : '';
        let email = inp['email'] ? inp['email'] : '';
        let p = inp['roles'] ? inp['roles'] : [];
        let e = inp['expire'] ? inp['expire'] : false;
        let obj = { name: name, email: email, message: inp.message, camera: camera, activeSceneId: this.scene.id, permissions: p.map(p => p.id), expiration: e };
        // console.log('map-service : addShare', inp, '/share/' + this.currentProject.id, obj);
        return this.fourD.V.api('/share/' + this.currentProject.id, 'post', obj).pipe(operators_1.flatMap(_ => this.currentProject.shareClients.limit(1000007).queryObservable().pipe(operators_1.tap(s => this.shareClients = s.items))));
    }
    /**
     * remove a share client
     * @param c
     */
    removeShare(c) {
        return c.destroyObservable().pipe(operators_1.tap(s => this.shareClients = this.shareClients.filter(cc => cc != c)));
    }
    /**
     * Triggers when the active scene is changed
     */
    onSceneChange(source = 'unknown') {
        // if (true || this.debug) { console.log('%c @@@@@@@@@@@@@@@@@@@@@@@@ map.service :: %c onSceneChange() ['+ source +'] @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', this.debugPrimary, this.debugSecondary, this.scene ); }
        /*
        if (this.scene) {
          setTimeout(() => {
            if (this.scene) {
              this._sceneChangeSubj.next(this.scene)
            } else {
              Constants.hideHangOn();
            }
          }, 200)
        } else {
          // if no scene then hide the hangon dialog
          Constants.hideHangOn();
        }
        */
        if (this.scene)
            return rxjs_2.concat([this.scene], this._sceneChangeObj);
        else
            return this._sceneChangeObj;
        /*
            if (this.scene) {
              Constants.hideHangOn();
              this._sceneChangeSubj.next(this.scene);
            } else {
              return this._sceneChangeObj
            }
          */
    }
    /**
     * Triggered when active scene will start changed (used for showing a loading spinner)
     */
    onSceneWillChange() {
        return this._sceneWChangeObj;
    }
    /**
     * trigger when annotation list changes (due to search or camera position)
     */
    onAnnotationsChange() {
        return this._annotChangeObs;
    }
    onTerranCompareStarted() {
        return this.terranCompareStartedObs;
    }
    onCesiumReady() {
        return this._cesiumReadyObj;
    }
    /**
     * trigger when a single annotation changes (due to meta data being updated)
     */
    onSingleAnnotationChange() {
        return this._annot1ChangeObs;
    }
    /**
     * trigger when photos change (due to search or camera position)
     */
    onPhotosChange() {
        return this._photoChangeObs;
    }
    /**
     * trigger when photos change (due to search or camera position)
     */
    onPhotosWillChange() {
        return this._photoWChangeObs;
    }
    /**
     * Check if a user / profile has seen the given tip. If not, display it.
     */
    checkForTip(tip, identifier) {
        // tip is an identifier for looking up the tip in the language file (in the 'TIPS' section)
        // identifier is a DOM identifier the tooltip box will point to / talk about
    }
    // AAAAAAAAAAARGH! What is a Cesium map function doing here!?! TODO : For this type of stuff, we should do this in the map.component.ts controller
    changeBaseModelColor(incoming = null) {
        let color = this.scene ? (this.scene['baseModelColor'] ? this.scene['baseModelColor'] : '#000') : '#444';
        if (incoming) {
            color = incoming;
        }
        this.viewer.scene.globe.baseColor = Cesium.Color.fromCssColorString(color);
        // console.log('map.service :: changeBaseModelColor()', color, this.viewer.scene.globe.baseColor, this.viewer.scene.backgroundColor );
    }
    showBaseModel(b) {
        // if (this.debug) {
        // }
        //if ( this.viewer && this.viewer.scene ) {
        // console.log('map.service :: showBaseModel()', b );
        let me = this;
        await_class_1.XsAwait.until('viewer.scene', this).then(_ => {
            me.viewer.scene.imageryLayers._layers[0].show = b;
            if (!b) {
                me.changeBaseModelColor();
                me.viewer.scene.backgroundColor = Cesium.Color.WHITE;
            }
            else {
                me.changeBaseModelColor('#fff');
                me.viewer.scene.backgroundColor = Cesium.Color.BLACK;
            }
        });
        //try {
        //} catch (e) {
        //  console.log(e.message);
        //}
        //} else {
        // console.log('map.service :: showBaseModel() ERROR', b );
        //}
    }
    showGlobeOnCesium(show) {
        if (this.debug) {
            console.log('map.service :: showGlobeOnCesium()');
        }
        if (this.viewer) {
            this.viewer.scene.globe.show = show;
            this.viewer.skyAtmosphere = show;
            this.viewer.scene.skyBox.show = show; //  = new Cesium.SkyBox({ show: show });
        }
    }
    clipPlanes(points, clip) {
        if (this.debug) {
            console.log('map.service :: clipPlanes()');
        }
        if (points && points.length < 3) {
            // this.openSnackBarError('You cannot clip less than 3 points.');
            return;
        }
        // Create clipping planes for polygon around area to be clipped.
        var pointsLength = points.length;
        var clippingPlanesEnabled = true;
        var edgeStylingEnabled = true;
        // Create center points for each clipping plane
        var clippingPlanes = [];
        for (var i = 0; i < pointsLength; ++i) {
            var nextIndex = (i + 1) % pointsLength;
            var midpoint = Cesium.Cartesian3.add(points[i]['coords'], points[nextIndex]['coords'], new Cesium.Cartesian3());
            midpoint = Cesium.Cartesian3.multiplyByScalar(midpoint, 0.5, midpoint);
            var up = Cesium.Cartesian3.normalize(midpoint, new Cesium.Cartesian3());
            var right = Cesium.Cartesian3.subtract(points[nextIndex]['coords'], midpoint, new Cesium.Cartesian3());
            right = Cesium.Cartesian3.normalize(right, right);
            var normal = Cesium.Cartesian3.cross(right, up, new Cesium.Cartesian3());
            normal = Cesium.Cartesian3.normalize(normal, normal);
            // Compute distance by pretending the plane is at the origin
            var originCenteredPlane = new Cesium.Plane(normal, 0.0);
            var distance = Cesium.Plane.getPointDistance(originCenteredPlane, midpoint);
            clippingPlanes.push(new Cesium.ClippingPlane(normal, distance));
        }
        this.viewer.scene.globe.clippingPlanes = new Cesium.ClippingPlaneCollection({
            planes: clippingPlanes,
            edgeWidth: edgeStylingEnabled ? 1.0 : 0.0,
            edgeColor: Cesium.Color.WHITE,
            enabled: clippingPlanesEnabled,
            unionClippingRegions: clip
        });
    }
    clipGlobe(event, transform) {
        if (this.debug) {
            console.log('map.service :: clipGlobe()');
        }
        if (event) {
            var centerPosition = [(transform.llng + transform.ulng) / 2, (transform.llat + transform.ulat) / 2];
            var position = Cesium.Cartesian3.fromDegrees(centerPosition[0], centerPosition[1], transform.height);
            var pos_ll = new Cesium.Cartesian3.fromRadians(transform.llng, transform.llat, 0);
            var pos_ur = new Cesium.Cartesian3.fromRadians(transform.ulng, transform.ulat, 0);
            var distance = Cesium.Cartesian3.distance(pos_ll, pos_ur);
            distance = distance - 100;
            if (!this.clipedEntity) {
                this.clipedEntity = this.viewer.entities.add({
                    name: 'clipped globe',
                    position: position,
                });
                var globe = this.viewer.scene.globe;
                var clippingPlanesEnabled = event;
                var edgeStylingEnabled = event;
                globe.clippingPlanes = new Cesium.ClippingPlaneCollection({
                    modelMatrix: this.clipedEntity.computeModelMatrix(Cesium.JulianDate.now()),
                    planes: [
                        new Cesium.ClippingPlane(new Cesium.Cartesian3(1.0, 0.0, 0.0), distance),
                        new Cesium.ClippingPlane(new Cesium.Cartesian3(-1.0, 0.0, 0.0), distance),
                        new Cesium.ClippingPlane(new Cesium.Cartesian3(0.0, 1.0, 0.0), distance),
                        new Cesium.ClippingPlane(new Cesium.Cartesian3(0.0, -1.0, 0.0), distance)
                    ],
                    edgeWidth: edgeStylingEnabled ? 1.0 : 0.0,
                    edgeColor: Cesium.Color.BLACK,
                    enabled: clippingPlanesEnabled
                });
                this.viewer.scene.globe.baseColor = Cesium.Color.BLACK;
                this.viewer.scene.backgroundColor = Cesium.Color.BLACK;
            }
        }
        else {
            if (this.clipedEntity) {
                this.viewer.entities.remove(this.clipedEntity);
                this.clipedEntity = undefined;
            }
            this.viewer.scene.globe.clippingPlanes = undefined;
        }
        this.viewer.scene.imageryLayers._layers[0].show = !event;
    }
    checkAndClipPlanesFromAnnotation() {
        if (this.debug) {
            console.log('map.service :: checkAndClipPlanesFromAnnotation()');
        }
        this.annotations.forEach(a => {
            if (a['clipPlanes'] !== undefined) {
                a['points'].forEach(point => {
                    this.clipPlanes(point, a['clipPlanes']);
                });
            }
        });
    }
    changeOpacity(t, _saveSubj, event) {
        if (this.debug) {
            console.log('map.service :: changeOpacity()');
        }
        if (this.isValidForChangingOpacity(t)) {
            var obj = this.helper.getCesiumObjectFor(t);
            //if ( this.debug ) { console.log ( 'map.service :: changeOpacity() transform, obj', t, obj ); }
            if (!obj)
                return;
            var opacity = event ? event.value : this.scene['layerProps'][MapService.ALPHA + t.id];
            if (t['ds_type_uid'] === 'geo-json' || t['ds_type_uid'] === 'kml' || t['ds_type_uid'] === 'shape-zip' && obj._entityCollection) {
                //if ( this.debug ) { console.log ( 'map.service :: changeOpacity() :: entities.forEach' ); }
                obj._entityCollection.values.forEach(e => {
                    if (this.debug) {
                        console.log('map.service :: changeOpacity() :: entity', e);
                    }
                    if (e.polyline && e.polyline.material && e.polyline.material.color) {
                        var color = new Cesium.Color(e.polyline.material.color._value.red, e.polyline.material.color._value.green, e.polyline.material.color._value.blue, opacity);
                        e.polyline.material.color = color;
                    }
                    else if (e.polygon && e.polygon.material && e.polygon.material.color) {
                        var color = new Cesium.Color(e.polygon.material.color._value.red, e.polygon.material.color._value.green, e.polygon.material.color._value.blue, opacity);
                        e.polygon.material.color = color;
                        if (opacity == 1) {
                            e.polygon.outline = true;
                        }
                        else {
                            e.polygon.outline = false;
                        }
                    }
                });
            }
            const c = 'rgba(255, 255, 255,' + Number(opacity) + ')';
            //if ( this.debug ) { console.log ( 'map.service :: changeOpacity() :: opacity', c, opacity, obj ); }
            // for objects that supports the alpha
            obj.alpha = opacity;
            // for objects that support tileStyles (uh, meaning, tiles ...)
            obj.style = new Cesium.Cesium3DTileStyle({
                color: t['colourStyle'] || c
            });
            if (_saveSubj)
                _saveSubj.next(this.viewer.scene);
        }
        else {
        }
    }
    reorderTransform() {
        // this.debug = true;
        if (this.debug) {
            console.log('%c map.service %c reorderTransform()', this.debugPrimary, this.debugSecondary, this.sceneTransforms, this.viewer);
        }
        // let final = [];
        // always have your terrain models at the bottom
        this.sceneTransforms = [...this.sceneTransforms.filter(t => t['isTerrain']), ...this.sceneTransforms.filter(t => !t['isTerrain'])];
        if (!this.currentProject['_coords']) {
            this.currentProject['_coords'] = {};
        }
        // if ( this.scene && !this.scene['cameraPosition'] ) {
        //   this.scene['cameraPosition'] = { x:this.viewer.camera.position.x, y:this.viewer.camera.position.y, z:this.viewer.camera.position.z };
        // }
        this.currentProject['_coords'][this.scene.id] = {
            default: { x: this.viewer.camera.position.x, y: this.viewer.camera.position.y, z: this.viewer.camera.position.z }
        };
        for (let i = this.sceneTransforms.length - 1; i >= 0; i--) {
            let t = this.sceneTransforms[i];
            let cObj = this.helper.getCesiumObjectFor(t);
            this.currentProject['_coords'][this.scene.id][t.id] = this.getCoordsFromItem(t);
            let meta = {};
            if (this.debug) {
                meta = {
                    idx: i,
                    toggle: this.scene['layerProps'][MapService.TOGGLE + t.id],
                    show: this.scene['layerProps'][MapService.VIEW + t.id],
                    name: this.sceneTransforms[i].name,
                    type: this.sceneTransforms[i].transformType.uid,
                    transform: t,
                    object: cObj
                };
            }
            // this.debug = true;
            if (cObj &&
                (this.sceneTransforms[i].transformType.uid === 'tms' || this.sceneTransforms[i].transformType.uid === 'wms-remote' || this.sceneTransforms[i].transformType.uid === 'arcgis-remote')) {
                this.viewer.imageryLayers.raiseToTop(cObj);
                if (this.debug) {
                    console.log('%c map.service %c reorderTransform(' + i + ') to top', this.debugPrimary, this.debugSecondary, meta);
                }
            }
            else {
                if (this.debug) {
                    console.log('%c map.service %c reorderTransform(' + i + ') to top (but not TMS)', this.debugPrimary, this.debugSecondary, meta);
                }
            }
            // this.debug = false;
        }
        // console.log('@@@@', this.currentProject['_coords'][this.scene.id] );
    }
    getCoordsFromItem(item) {
        let coords = { latitude: null, longitude: null, height: null };
        if (item['firstTransformCoords']) {
            coords = item['firstTransformCoords'];
        }
        if (item['__cameras'] && item['__cameras'][0]) {
            const carto = Cesium.Ellipsoid.WGS84.cartesianToCartographic(item['__cameras'][0]['data']['position']);
            if (carto && carto['longitude']) {
                coords.longitude = Cesium.Math.toDegrees(carto.longitude);
                coords.latitude = Cesium.Math.toDegrees(carto.latitude);
                coords.height = carto.height;
            }
        }
        if (item.props['cameraPosition'] && item.props['cameraPosition']['position']) {
            const carto = Cesium.Ellipsoid.WGS84.cartesianToCartographic(item.props['cameraPosition']['position']);
            if (carto && carto['longitude']) {
                coords.longitude = Cesium.Math.toDegrees(carto.longitude);
                coords.latitude = Cesium.Math.toDegrees(carto.latitude);
            }
        }
        if (item['cameraPosition']) {
            if (item['cameraPosition']['longitude']) {
                coords = item['cameraPosition'];
            }
            else {
                const carto = Cesium.Ellipsoid.WGS84.cartesianToCartographic(item['cameraPosition']);
                if (carto && carto['longitude']) {
                    coords.longitude = Cesium.Math.toDegrees(carto.longitude);
                    coords.latitude = Cesium.Math.toDegrees(carto.latitude);
                }
            }
        }
        if (item.llng && item.llat) {
            coords.longitude = item.llng;
            coords.latitude = item.llat;
            coords.height = item.lheight;
        }
        return coords;
    }
    flyTo(annotation) {
        if (this.debug) {
            console.log('map.service :: flyTo(annotation)', annotation);
        }
        if (this.helper.getCesiumObjectFor(annotation)) {
            this.viewer.flyTo(this.helper.getCesiumObjectFor(annotation).pin, {
                duration: 1,
                maximumHeight: this.viewer.camera.height,
                offset: new Cesium.HeadingPitchRange(this.viewer.camera.heading, this.viewer.camera.pitch, this.getCameraHeight())
            });
        }
    }
    flyToRefPin(refPin) {
        if (this.debug) {
            console.log('map.service :: flyToRefPin(refPin)', refPin);
        }
        this.viewer.flyTo(refPin, {
            duration: 1,
            maximumHeight: this.viewer.camera.height,
            offset: new Cesium.HeadingPitchRange(this.viewer.camera.heading, this.viewer.camera.pitch, this.getCameraHeight())
        });
    }
    getCameraHeight() {
        if (this.debug) {
            console.log('map.service :: getCameraHeight()');
        }
        var camera = this.viewer.scene.camera;
        var ellipsoid = this.viewer.scene.globe.ellipsoid;
        var camera_height = ellipsoid.cartesianToCartographic(camera.position).height;
        return camera_height;
    }
    isValidForChangingOpacity(t) {
        // less concise but clearer and extendable version
        if (!t) {
            return false;
        }
        // no opacity for laslaz and terrains (note: the colorizer plugin enables opacity for some of these)
        if (t && (t['ds_type_uid'] == 'laslaz-tiles' || t['type_uid'] == 'terrain-tiles')) {
            return false;
        }
        // hack!!! Any layer with 'Tower' in the name can't have opacity because we currently can't deal with older tilesets properly
        if (t.name.indexOf('Tower') !== -1) {
            return false;
        }
        // console.log ( 'ss:', t['ds_type_uid'], t['type_uid'], t.name.indexOf('Tower') );
        return true;
    }
    checkAndClipPlanesFromTransforms() {
        if (this.debug) {
            console.log('map.service :: checkAndClipPlanesFromTransforms()');
        }
        if (this.sceneTransforms && this.sceneTransforms.length > 0) {
            this.sceneTransforms.forEach(t => {
                if (t['clipGlobe'] != undefined) {
                    this.clipedEntity = undefined;
                    this.clipGlobe(t['clipGlobe'], t);
                    return;
                }
            });
        }
    }
    // revert all the cesium functionality which was disabled due to fake location
    enableCesiumFunctionsForFakeLocation(enable) {
        this.viewer.scene.globe.show = enable;
        this.viewer.skyAtmosphere = enable;
        this.viewer.scene.skyBox = new Cesium.SkyBox({
            show: enable
        });
        this.viewer.scene.screenSpaceCameraController.enableRotate = enable;
        this.viewer.scene.screenSpaceCameraController.enableTranslate = enable;
        this.viewer.scene.screenSpaceCameraController.enableZoom = enable;
        this.viewer.scene.screenSpaceCameraController.enableTilt = enable;
        this.viewer.scene.screenSpaceCameraController.enableLook = enable;
    }
    saveSceneTransformsOrders() {
        if (this.debug) {
            console.log('%c map.service %c saveSceneTransformsOrders()', this.debugPrimary, this.debugSecondary);
        }
        if (this.scene) {
            if (this.sceneTransforms.length > 0) {
                this.scene['sceneTransformsOrder'] = this.sceneTransforms.map(st => st.id);
            }
            else {
                delete this.scene['sceneTransformsOrder'];
            }
            this.scene.saveObservable().subscribe();
        }
    }
    // reorder the scene transforms order
    reorderSavedSceneTranformOrders() {
        var original = this.sceneTransforms;
        if (this.debug) {
            console.log('%c map.service %c reorderSavedSceneTranformOrders()', this.debugPrimary, this.debugSecondary);
        }
        if (this.scene['sceneTransformsOrder'] && this.scene['sceneTransformsOrder'].length > 0) {
            let transformsCopy = [];
            // if saved sceneTransformsOrder array is not same as current sceneTransforms  means current sceneTransforms has been updated so push the recently added transforms in top of the order list
            if (this.sceneTransforms.length > this.scene['sceneTransformsOrder'].length) {
                this.sceneTransforms.forEach(st => {
                    let index = this.scene['sceneTransformsOrder'].findIndex(id => st.id === id);
                    if (index === -1) {
                        transformsCopy.push(st);
                    }
                });
            }
            this.scene['sceneTransformsOrder'].forEach(id => {
                let index = this.sceneTransforms.findIndex(st => st.id === id);
                if (index !== -1) {
                    transformsCopy.push(this.sceneTransforms[index]);
                }
            });
            this.sceneTransforms = transformsCopy;
        }
        if (original.length != this.sceneTransforms.length) {
            // SJ - Dunno how this happens but it does some times, not gonna look any harder, its sat night, im tried
            // revert to the original list
            this.sceneTransforms = original;
        }
    }
    getTransformColorFile(transform) {
        return this.httpClient.get(transform.file('color.txt'), { responseType: 'text' });
    }
    getTransformHeightFile(transform) {
        return this.httpClient.get(transform.file('minmax.txt'), { responseType: 'text' });
    }
    set annotationValues(a) {
        this.annotations = a;
        this._annotChangeSubj.next(a.slice());
    }
}
MapService.TOGGLE = 'toggle_';
MapService.ALPHA = 'alpha_';
MapService.VIEW = 'view_';
MapService.FEET = 'Feet';
MapService.METER = 'Meter';
MapService.DEFAULT_GROUP = 'DEFAULT';
MapService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MapService_Factory() { return new MapService(i0.ɵɵinject(i1.FourDService), i0.ɵɵinject(i2.AclService), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(i4.HttpClient), i0.ɵɵinject(i5.XsApplicationEventsService), i0.ɵɵinject(i6.MapDataService)); }, token: MapService, providedIn: "root" });
exports.MapService = MapService;
